import { BoardsGroupInfo } from '@descomplica/dex-models';

export interface BoardsGroupState {
  boardsGroups: { [key: string]: BoardsGroupInfo };
}

const state: BoardsGroupState = {
  boardsGroups: {},
};

export default state;
